<template>
  <div>

    <data-table :title="title"
      :url="'/agreements/' + (this.telcoId ? '/org/' + this.telcoId : '')"
      table-ref="agreements-table"
      :fields="fields"
      :hide-top="hideTop"
      :show-search="showSearch"
      :show-refresh="showRefresh"
      :search-placeholder="searchPlaceholder"
      :add-action="noAdd ? null : action"
      :add-props="noAdd ? null : addPropsData"
      detail-component="agreement-detail-row" />

    </div>
</template>


<script>
import Vue from 'vue'

import AgreementControls from '@/components/finance/rates/AgreementControls'
import AgreementDetails from '@/components/finance/rates/AgreementDetails'
import AgreementAction from '@/components/actions/AgreementAction'

Vue.component('agreement-controls', AgreementControls)
Vue.component('agreement-detail-row', AgreementDetails)

export default {
/*
  components: {
    StructControls,
    StructAction
  },
*/
  props: {
    noAdd: {
      type: Boolean,
      default: false
    },
    siteId: {
      type: Number,
      default: null
    },
    owner: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: 'Agreements'
    },
    hideTop: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: 'Name, Category, Status...'

    }
  },
  data () {
    return {
      telcoId: this.isTelco() ? Number(this.org().id) : this.owner,
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'rateGroupId',
          title: 'Rate Group ID',
          sortField: 'rateGroupId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'category',
          title: 'Category',
          sortField: 'category'
        },
        {
          name: 'name',
          title: 'Name',
          sortField: 'name'
        },
        {
          name: 'organisation.shortName',
          title: 'Org. Name'
        },
        {
          name: 'rates.length',
          title: '# Rates'
        },
        {
          name: '__component:agreement-controls',
          title: ''
        }
      ],
      action: AgreementAction,
      addPropsData: {
        rowData: this.rowData,
        editMode: false
      }
    }
  },  // data

  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}

</script>
